import { getBaseUrl } from '@/utils/utils.js';
import i18next from 'i18next';
import {
  getUserProjects, getUserconfig, saveUserconfig, getEPSGs, getProcessTypes,
  getCustomersData, getProcessStatus, getRoles, generateShareableLink,
  getPermissions,
  getCustomersLayerTypes,
  getSensorTypes,
  getExternalGeoServices,
  getProjectExternalGeoServices,
  getCustomerRolesAPI
} from '@/apis/Apis.js';

import {
  setUserConfigs, setUserInfo, logout, setviewerConfig, setActiveProject,
  initviewerConfig, setErrors, setProjects, setEpsgs, setProcessTypes, setCusomers,
  setProcessStatuses, setActiveCustomer, setLoadingProjects, setRoles,
  setLanguage, setLoading, setShareLink, setGeneratingShareLink, setUserToken,
  setChangeLogs, setchangeLogConfigs,
  setPermissions,
  setLastURL,
  setTrackLayerTypes,
  setSensorTypes,
  setExternalGeoServices,
  setProjectExternalGeoServices,
  setCenteredNotification,
  setActiveCustomerRoles,
  initClearanceInspectorConfig,
  toggleShowNews
} from './appSlice.js';
import { loadDBState } from '../potree/potreeSlice.js';
import { loadDropDownDBState } from '../dropdown/dropdownSlice.js';
import { TransformationService } from '@drones2bim/geo-spatial-engine';

export const login = (userData) => async dispatch => {
  dispatch(setLoading(true))
  try {
    // console.log(userData)
    if (userData) {
      const userRoles = userData.profile && userData.profile.resource_access ? userData.profile.resource_access.X2BIMWEB.roles : []
      let userinfo = {
        userId: userData.profile.userId,
        displayName: userData.profile.name,
        preferred_username: userData.profile.preferred_username,
        isAdmin: userRoles.includes("Superadministrator") || userRoles.includes("Administrator"),
        isSuperAdmin: userRoles.includes("Superadministrator"),
        userRoles: userRoles,
       
      }

      dispatch(setUserInfo(userinfo))
      await dispatch(setUserToken(userData.access_token))
      dispatch(setupUserData())
    } else {
      dispatch(logout())
      dispatch(setLoading(false))
    }

  }
  catch (e) {
    console.error(e)
    dispatch(logout())
    dispatch(setLoading(false))
  }
}

export const getChangeLogs = () => async (dispatch, getState) => {
  try {
    const state = getState()

    const response = await fetch(`${getBaseUrl()}/cms/api/releasenotes/`)
    if (!response.ok) throw new Error(`HTTP ${response.status}`)

    const data = await response.json()
    if (!data?.docs) throw new Error("unexpected response shape")

    const changeLogs = data.docs.filter(row => row["_status"] === "published")

    await dispatch(setChangeLogs(changeLogs))

    const localStore = JSON.parse(localStorage.getItem("readList")) || []
    const docIds = changeLogs.map(row => { return { id: row.id, forceRead: row.forceRead } })
    const isAllchangeLogsRead = docIds.every(row => localStore.includes(row.id))
    const forceRead = docIds.some(row => !localStore.includes(row.id) && row.forceRead)
    await dispatch(setchangeLogConfigs({ isUnread: !isAllchangeLogsRead, forceOpen: forceRead }))
  } catch (e) {
    console.warn("getChangeLogs:", e.message)
  }
}

export const markAllAsRead = (ids) => async dispatch => {

  localStorage.setItem("readList", JSON.stringify(ids))
  await dispatch(setchangeLogConfigs({isUnread:false, forceOpen:false}))

}

export const setupUserData = () => async dispatch => {
  try {


    dispatch(userConfig())
    dispatch(getEpsgCodes())
    dispatch(getProcessTypeData())
    dispatch(getSensorTypeData())
    dispatch(getProcessStatusData())
    
    dispatch(setPermissionsFromAPI())
  }
  catch (e) {
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const setRolesFromAPI = (activeCustomerId) => async dispatch => {
  if(!activeCustomerId) {
    console.error("No active customer id")
    return
  }
  try {
    const roles = await getRoles(activeCustomerId)
    const rolesDict = roles.reduce((acc, value) => {
      return { ...acc, [value.roleId]: value, [value.roleName]: { ...value, cloned: true } };
    }, {})
    dispatch(setRoles(rolesDict))
  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const setPermissionsFromAPI = () => async dispatch => {
  try {
    const permissions = await getPermissions()
    const permissionsict = permissions.reduce((acc, value) => {
      return { ...acc, [value.name]:value.name };
    }, {})
    dispatch(setPermissions(permissionsict))
  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const getEpsgCodes = () => async dispatch => {
  try {
    const epsgs = await getEPSGs()

    const epsgsForTransformService = epsgs
      .filter(row => {
        const proj4str = row?.crsstring || row?.crsString;
        return Number.isFinite(row?.epsgCode) && !row.deprecated && typeof proj4str === 'string' && proj4str.length > 0;
      })
      .map(row => ({
        code: Number(row.epsgCode),
        proj4: row.crsstring || row.crsString,
      }))
    TransformationService.setEpsgs(epsgsForTransformService)

    const epsgsDict = epsgs.filter(row => !row.deprecated).reduce((acc, value) => {
      return { ...acc, [value.epsgCode]: value };
    }, {})
    dispatch(setEpsgs(epsgsDict))
  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const setupUserCustomerData = (activeCustomerId) => async dispatch => {
  try {
    const customers = await getCustomersData()
    if (!customers || customers.length === 0) {
      console.error("No customers available")
      dispatch(setCenteredNotification({ message: i18next.t("dashboard.noCustomerWarning") }))
      dispatch(setLoading(false))
      dispatch(setProjects([]))
      return
    }
    const customersDict = customers.reduce((acc, value) => {
      return { ...acc, [value.customerId]: value };
    }, {})

    dispatch(setCusomers(customersDict))
    dispatch(setActiveCustomerId(activeCustomerId && typeof activeCustomerId == "string" ? activeCustomerId : customers[0]?.customerId))
  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const setActiveCustomerId = (customerId) => async dispatch => {
  if (!customerId) {
    console.error("No active customer id")
    dispatch(setProjects([]))
    return
  }
  try {
    dispatch(setLoadingProjects())
    dispatch(setActiveCustomer(customerId))
    dispatch(setUserProjects(customerId))
    dispatch(setRolesFromAPI(customerId))
    dispatch(getCustomerRoles(customerId) )
    dispatch(fetchExternalGeoServices(customerId))
    
    const customerLayerTypes = await getCustomersLayerTypes(customerId)
    dispatch(setTrackLayerTypes(customerLayerTypes))
  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const getCustomerRoles = (customerId) => async dispatch => {
  if (!customerId) {
    console.error("No active customer id")
    return
  }
  try {
    const roles = await getCustomerRolesAPI(customerId)
    

    dispatch(setActiveCustomerRoles(roles))
  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const getProcessTypeData = () => async dispatch => {
  try {
    const processTypes = await getProcessTypes()


    const pTypeDict = processTypes.filter(row => !row["processTypeDesc"] !== "disabled").reduce((acc, value) => {
      return { ...acc, [value.processTypeName]: value, [value.processTypeId]: value };
    }, {})
    dispatch(setProcessTypes(pTypeDict))
  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const getSensorTypeData = () => async dispatch => {
  try {
    const sensorTypes = await getSensorTypes()


    const pTypeDict = sensorTypes.reduce((acc, value) => {
      return { ...acc, [value.sensorTypeName]: value, [value.sensorTypeId]: value };
    }, {})
    dispatch(setSensorTypes(pTypeDict))
  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const getProcessStatusData = () => async dispatch => {
  try {
    const processStatuses = await getProcessStatus()
    const pTypeDict = processStatuses.reduce((acc, value) => {
      return { ...acc, [value.processStatusName]: value, [value.processStatusId]: value };
    }, {})
    dispatch(setProcessStatuses(pTypeDict))
  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const setUserProjects = (customerId) => async dispatch => {
  try {

    if (customerId) {
      const projects = await getUserProjects(customerId)
      dispatch(setProjects(projects))
    } else {
      dispatch(setProjects([]))
      console.error("No Customer relationship")
    }

  }
  catch (e) {
    console.log("e", e)
    dispatch(setErrors(e.message))
    return console.error(e.message);
  }
}

export const userConfig = () => async dispatch => {
  try {
    
    const savedDataFromDB = await getUserconfig()
    
    let parsedData = savedDataFromDB

    if (parsedData) {
      const { activeProjectId = false, userConfig, viewerConfig, clearanceInspectorConfig, activeCustomerId, language, potreeConfig, dropdown, lastURL, showNews } = parsedData

      dispatch(setupUserCustomerData(activeCustomerId))
      dispatch(setActiveCustomer(activeCustomerId))
      dispatch(setActiveProject(activeProjectId))
      dispatch(setUserConfigs(userConfig))
      dispatch(initviewerConfig(viewerConfig))
      dispatch(initClearanceInspectorConfig(clearanceInspectorConfig))
      dispatch(loadDBState(potreeConfig))
      dispatch(loadDropDownDBState(dropdown))
      dispatch(setLastURL(lastURL || "/dashboard"))
  
      if (language) {
        dispatch(setLanguage(language))
      }
      if (showNews !== undefined) {
        dispatch(toggleShowNews(showNews))
      }
    }

  }
  catch (e) {

    dispatch(setErrors("No Users configuration found."))
    return console.error(e.message);
  }
}

export const updateViewerConfig = (activeProjectId, viewerConfig) => async (dispatch, getState) => {
  try {
    await dispatch(setviewerConfig({ activeProjectId, viewerConfig }))
    dispatch(saveToServer())
  }
  catch (e) {
    return console.error(e.message);
  }
}

export const generateShareLink = (data) => async (dispatch, getState) => {
  try {
    const response = await generateShareableLink(data)
    await dispatch(setShareLink(response))
  }
  catch (e) {
    dispatch(setGeneratingShareLink(false))
    dispatch(setErrors(e.message))
    return console.error(e.message);

  }
}

export const updateUserFavorite = (projectId) => async (dispatch, getState) => {
  try {

    const state = getState()
    const copiedUserConfig = { ...state.app.userConfig }
    let userFavs = state.app.userConfig.favoriteProjects ? [...state.app.userConfig.favoriteProjects] : []
    if (userFavs.length && userFavs.includes(projectId)) {
      userFavs = userFavs.filter(id => id != projectId)
    } else {
      userFavs.push(projectId)
    }

    copiedUserConfig.favoriteProjects = userFavs
    dispatch(setUserConfigs(copiedUserConfig))
  }
  catch (e) {
    return console.error(e.message);
  }
}

export const saveToServer = () => async (dispatch, getState) => {
  try {
    const state = getState()

    const dataToPost = {
      language: state.app.language,
      activeCustomerId: state.app.activeCustomerId,
      activeProjectId: state.app.activeProjectId,
      viewerConfig: state.app.viewerConfig,
      clearanceInspectorConfig: state.app.clearanceInspectorConfig,
      userConfig: state.app.userConfig,
      potreeConfig: state.potree,
      dropdown:state.dropdown,
      lastURL: state.app.lastURL,
      showNews: state.app.showNews
    }
    await saveUserconfig(dataToPost)
  }
  catch (e) {
    return console.error(e.message);
  }
}

export const logoutUser = () => async dispatch => {
  try {

    await dispatch(logout())
  }
  catch (e) {
    return console.error(e.message);
  }
}

export const refreshToken = (token) => {
  //dispatch(setUserToken(token))
}

export const fetchExternalGeoServices = (customerId) => async dispatch => {
  try {
    const services = await getExternalGeoServices(customerId)
    dispatch(setExternalGeoServices(services))
  } catch (e) {
    console.error("fetchExternalGeoServices error:", e.message)
  }
}

export const fetchProjectExternalGeoServices = (projectId) => async dispatch => {
  try {
    const services = await getProjectExternalGeoServices(projectId)
    dispatch(setProjectExternalGeoServices(services))
  } catch (e) {
    console.error("fetchProjectExternalGeoServices error:", e.message)
  }
}